// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"196":"67689f5b","583":"b91d5882","845":"4997fbcb"}[chunkId] + ".chunk.js");